module.exports = __webpack_public_path__ + "media/new_shopper_bonus/balloons@2x-3f5cff27.png";